import { render, staticRenderFns } from "./SettingsPageCard.vue?vue&type=template&id=597523ff"
import script from "./SettingsPageCard.vue?vue&type=script&lang=js"
export * from "./SettingsPageCard.vue?vue&type=script&lang=js"
import style0 from "./SettingsPageCard.vue?vue&type=style&index=0&id=597523ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports